import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon29: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#32BBC3"
        d="M9.5.5v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-1 0Zm0 17v2a.5.5 0 0 0 1 0v-2a.5.5 0 0 0-1 0Zm-9-7h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1Zm17 0h2a.5.5 0 0 0 0-1h-2a.5.5 0 0 0 0 1ZM20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10Zm-1 0a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9Zm-4.297-5.389a.5.5 0 0 1 .679.68l-3.531 6.36a.484.484 0 0 1-.195.194l.061-.039a.435.435 0 0 1-.057.038l-6.363 3.533c-.439.244-.923-.24-.679-.68l3.531-6.36.008-.014.018-.027c.008-.014.018-.026.028-.038l.025-.027a.48.48 0 0 1 .111-.086l6.364-3.534ZM8.7 9.401l-2.359 4.253 4.25-2.362L8.7 9.401Zm4.959-3.066-4.25 2.361 1.89 1.89 2.36-4.251Z"
      />
    </Svg>
  )
}
